module.exports = __webpack_public_path__ + "faq/img/problem1.b8bcd6b3.png";